import * as NewsEffects from './news.effect';
import * as featuredNewsEffects from './featured-news.effect';

export const effects = { ...NewsEffects, ...featuredNewsEffects };
